import { Component, Inject, ViewEncapsulation, OnInit, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Misc } from '../util/misc';
import { Status } from 'src/app/models/status.model';
import { EstimativaTipo } from 'src/app/models/estimativa-tipo.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { EstimativaTipoService } from 'src/app/services/estimativa-tipo.service';
import { StatusService } from 'src/app/services/status.service';
import { UtilService } from 'src/app/services/util.service';
import { Estimativa } from 'src/app/models/estimativa.model';

@Component({
    selector: 'app-estimativa-form-component',
    templateUrl: 'estimativa-form.component.html',
    styleUrls: ['estimativa-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EstimativaFormComponent implements OnInit {
    public keyUp = new Subject<Event>();

    basicForm: UntypedFormGroup;
    status: Status[] = [];
    loading = false;
    tipos: EstimativaTipo[] = [];

    constructor(
        public dialogRef: MatDialogRef<EstimativaFormComponent>,
        protected estimativaService: EstimativaService,
        protected estimativaTipoService: EstimativaTipoService,
        protected misc: Misc,
        protected statusService: StatusService,
        protected toastr: ToastrComponent,
        public utilService: UtilService,
        private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.createForm();

        const subscription = this.keyUp.pipe(
            debounceTime(250)
        ).subscribe(result => {
            this.enterSave();
        });
    }

    ngOnInit() {
        this.loading = true;

        this.estimativaTipoService.getAll().subscribe(
            result => {
                this.tipos = result.items;
            },
            error => {
                this.misc.processError(error, 'Não foi possível recuperar a lista de tipos de estimativa.');
            },
            () => {
                this.loading = false;
            }
        );
    }

    createForm() {
        this.basicForm = this.fb.group({
            id: [0],
            nome: [null, [Validators.required]],
            estimativaTipoId: [null, [Validators.required]],
            statusId: new UntypedFormControl({ value: 1, disabled: true}),
            usuarioId: [this.utilService.getUserId()]
        });
    }

    close(): void {
        this.dialogRef.close();
    }

    enterSave() {
        if (!this.basicForm.valid) {
            return;
        }

        this.loading = true;

        this.save();
    }

    save() {
        this.loading = true;

        const estimativa: Estimativa = this.basicForm.value;
        estimativa.projetoId = this.data.projetoId;
        estimativa.statusId = 1;
        estimativa.pracaId = 1;
        estimativa.negocioId = 1;
        estimativa.unidadeId = 1;

        this.estimativaService.create(estimativa)
            .subscribe(() => {
                this.loading = false;
                this.close();
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro salvo com sucesso');
            }, err => {
                this.loading = false;
                this.toastr.mostrarMensagem('erro', 'Erro', 'Erro ao salvar o registro');
            });
    }
}
